import React from "react";
import Icon from "components/AppIcon";

const FEATURES = [
  {
    icon: "Users",
    title: "Member Management",
    description: "Complete member profiles, registration, package assignment, and lifecycle tracking from onboarding to renewal.",
    span: "col-span-1 sm:col-span-2",
    accent: "teal",
  },
  {
    icon: "ScanLine",
    title: "Attendance Tracking",
    description: "QR code check-ins, biometric integration, and real-time attendance dashboards.",
    span: "col-span-1",
    accent: "blue",
  },
  {
    icon: "CreditCard",
    title: "Billing & Invoicing",
    description: "Automated billing cycles, payment reminders, and digital invoice generation.",
    span: "col-span-1",
    accent: "emerald",
  },
  {
    icon: "BarChart3",
    title: "Analytics & Reports",
    description: "Revenue waterfalls, churn prediction, cohort analysis, and custom report exports.",
    span: "col-span-1",
    accent: "violet",
  },
  {
    icon: "Building2",
    title: "Multi-Branch CRM",
    description: "Manage unlimited gym locations from a single dashboard with branch-level performance comparison.",
    span: "col-span-1 sm:col-span-2",
    accent: "amber",
  },
];

const accentMap = {
  teal: { bg: "bg-teal-500/10", icon: "#2dd4bf", border: "border-teal-500/20" },
  blue: { bg: "bg-blue-500/10", icon: "#60a5fa", border: "border-blue-500/20" },
  emerald: { bg: "bg-emerald-500/10", icon: "#34d399", border: "border-emerald-500/20" },
  violet: { bg: "bg-violet-500/10", icon: "#a78bfa", border: "border-violet-500/20" },
  amber: { bg: "bg-amber-500/10", icon: "#fbbf24", border: "border-amber-500/20" },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-teal-400 text-sm font-semibold font-caption uppercase tracking-wider">Platform Features</span>
          <h2 className="text-4xl sm:text-5xl font-bold font-heading mt-3 mb-4">
            Everything your gym needs
          </h2>
          <p className="text-slate-400 font-body max-w-xl mx-auto">
            From solo studios to multi-chain operations — myfitnesstracking scales with your business.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {FEATURES?.map((feature) => {
            const colors = accentMap?.[feature?.accent];
            return (
              <div
                key={feature?.title}
                className={`${feature?.span} group p-6 rounded-2xl bg-slate-900/60 border border-white/5 hover:border-white/10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/20`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors?.bg} border ${colors?.border} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={feature?.icon} size={22} color={colors?.icon} />
                </div>
                <h3 className="text-lg font-bold text-white font-heading mb-2">{feature?.title}</h3>
                <p className="text-slate-400 text-sm font-body leading-relaxed">{feature?.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
